import { i18n } from '@migros/msrc-i18n';
import { IconButton, IconChevronLeft, IconChevronRight, isPropValid, styled } from '@migros/msrc-ui-kit';
import React from 'react';
import { useI18n } from '../../hooks/use-i18n';
export let Slide = /*#__PURE__*/function (Slide) {
  Slide["prev"] = "prev";
  Slide["next"] = "next";
  return Slide;
}({});
export const ArrowPrev = ({
  className,
  onClick,
  customOnClick,
  language
}) => {
  useI18n(language);
  return /*#__PURE__*/React.createElement(React.Fragment, null, className === 'slick-arrow slick-prev slick-disabled' ? '' : /*#__PURE__*/React.createElement(StyledArrow, {
    onClick: e => {
      if (onClick) {
        if (customOnClick) {
          customOnClick();
        }
        onClick(e);
      }
    },
    type: Slide.prev,
    "data-testid": "msrc-articles--slider-arrow-prev"
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(IconChevronLeft, null),
    ariaLabel: i18n.t('components.arrows.back')
  })));
};
export const ArrowNext = ({
  className,
  onClick,
  customOnClick,
  language
}) => {
  useI18n(language);
  return /*#__PURE__*/React.createElement(React.Fragment, null, className === 'slick-arrow slick-next slick-disabled' ? '' : /*#__PURE__*/React.createElement(StyledArrow, {
    onClick: e => {
      if (onClick) {
        if (customOnClick) {
          customOnClick();
        }
        onClick(e);
      }
    },
    type: Slide.next,
    "data-testid": "msrc-articles--slider-arrow-next"
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(IconChevronRight, null),
    ariaLabel: i18n.t('components.arrows.next')
  })));
};
const StyledArrow = styled.div.withConfig({
  shouldForwardProp: isPropValid
})`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  left: ${props => props.type === Slide.prev ? 0 : ''};
  right: ${props => props.type === Slide.next ? 0 : ''};
`;